import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { adminMainUrl } from '../../../../../../../Config';
import { toast } from 'react-toastify';
import Select from 'react-select'
import Modal from 'react-bootstrap/Modal'; // added for modal
import { customStyles } from '../../../../../../../HelperFunctions';
import InputTextJSX from './InputTextJSX';
import { useDispatch, useSelector } from 'react-redux';
import { getFFSeaExpConsigneeBranch, getFFSeaExpConsigneeBranchBank, getFFSeaExpShipperBranch, getFFSeaExpShipperBranchBank, getFFSECity, getFFSECountry, getFFSESeaport, getFFSEState } from '../../../../../../../Redux/action/FreightForwarding/Sea/FFSeaExpAction';
import { Link, useNavigate } from 'react-router-dom';
import {
    applyNoOfCopiesValidation,
    handleNoOfCopiesInputChange,
    handleTypeOfBlSelectChange,
} from './ffBlCopiesFieldUtils';

const DirectShipmentSEMBLEdit = ({
    trans_mode,
    job_order_id,
    quotation_id,
    loadingCurrency,
    currencyOptions,
    loadingAirport,
    airportOptions,
    loadingOrganisation,
    organisationOptions,
    token,
    user_id,
    FFSeaExpDirectMAWBDetail,
    b64id,
    accessedPermission
}) => {
    const [disableSubmit, setDisableSubmit] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Options for "Type of BL" dropdown
    const blTypeOptions = [
        { value: 'Original BL', label: 'Original BL' },
        { value: 'Seaway BL', label: 'Seaway BL' },
    ];

    // Options for "Seal Type" dropdown
    const sealTypeOptions = [
        { value: 'Shipper', label: 'Shipper' },
        { value: 'Customer', label: 'Customer' },
        { value: 'Bolt', label: 'Bolt' },
    ];

    // ---- State for Add Row Modal ----
    const [showAddRowModal, setShowAddRowModal] = useState(false);
    const [newRowData, setNewRowData] = useState({
        container_number: '',
        line_seal_no: '',
        seal_type: '',
        seal_number: '',
        invoice_no: '',
        no_of_package: '',
        goods_description: '',
        gross_weight: '',
        gross_weight_unit: 'Kg',
        volume: '',
        volume_unit: 'CBM',
    });

    useEffect(() => {
        if (token && user_id) {
            dispatch(getFFSECountry(token, user_id));
            dispatch(getFFSESeaport(token, user_id));
        }
    }, []);

    let [shipperOrganisationOptions, setShipperOrganisationOptions] = useState([]);
    let [consigneeOrganisationOptions, setConsigneeOrganisationOptions] = useState([]);

    let [shipperBranchOptions, setShipperBranchOptions] = useState([]);
    let [consigneeBranchOptions, setConsigneeBranchOptions] = useState([]);

    let [shipperBankOptions, setShipperBankOptions] = useState([]);
    let [consigneeBankOptions, setConsigneeBankOptions] = useState([]);

    let [countryOptions, setCountryOptions] = useState([]);
    let [stateOptions, setStateOptions] = useState([]);
    let [cityOptions, setCityOptions] = useState([]);
    let [seaportOptions, setSeaportOptions] = useState([]);

    useEffect(() => {
        if (organisationOptions) {
            let shipperArr = [];
            let consigneeArr = [];

            organisationOptions.map(object => {
                if (object.entity && object.entity.includes("shipper")) {
                    shipperArr.push(object);
                }
                if (object.entity && object.entity.includes("consignee")) {
                    consigneeArr.push(object);
                }
            });
            setShipperOrganisationOptions(shipperArr);
            setConsigneeOrganisationOptions(consigneeArr);
        }
    }, [organisationOptions]);


    const handleShipperBranch = (shipper_id) => {
        if (shipper_id && token && user_id) {
            dispatch(getFFSeaExpShipperBranch(token, user_id, shipper_id));
        }
    };
    const handleShipperBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFSeaExpShipperBranchBank(token, user_id, branch_id));
        }
    };

    const handleConsigneeBranch = (consignee_id) => {
        if (consignee_id && token && user_id) {
            dispatch(getFFSeaExpConsigneeBranch(token, user_id, consignee_id));
        }
    };
    const handleConsigneeBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFSeaExpConsigneeBranchBank(token, user_id, branch_id));
        }
    };


    const {
        //organisation shipper branch list
        loadingFFSeaExpShipperBranchList,
        FFSeaExpShipperBranchList,
        FFSeaExpShipperBranchListError,

        //organisation consignee branch list
        loadingFFSeaExpConsigneeBranchList,
        FFSeaExpConsigneeBranchList,
        FFSeaExpConsigneeBranchListError,

        //organisatoin shipper branch bank list
        loadingFFSeaExpShipperBranchBankList,
        FFSeaExpShipperBranchBankList,
        FFSeaExpShipperBranchBankListError,

        //organisatoin consignee branch bank list
        loadingFFSeaExpConsigneeBranchBankList,
        FFSeaExpConsigneeBranchBankList,
        FFSeaExpConsigneeBranchBankListError,


        //country city state seaport
        loadingFFSECountry,
        FFSECountry,
        FFSECountryError,
        loadingFFSEState,
        FFSEState,
        FFSEStateError,
        loadingFFSECity,
        FFSECity,
        FFSECityError,
        loadingFFSESeaport,
        FFSESeaport,
        FFSESeaportError,
    } = useSelector(state => state.FFSeaExpReducer);


    useEffect(() => {
        if (FFSECountry) {
            let arr = [];
            FFSECountry.map(val => arr.push({ value: val.id, label: val.name }));
            setCountryOptions(arr);
        }
    }, [loadingFFSECountry, FFSECountry])

    useEffect(() => {
        if (FFSEState) {
            let arr = [];
            FFSEState.map(val => arr.push({ value: val.id, label: val.name }));
            setStateOptions(arr);
        }
    }, [loadingFFSEState, FFSEState]);

    useEffect(() => {
        if (FFSECity) {
            let arr = [];
            FFSECity.map(val => arr.push({ value: val.id, label: val.name }));
            setCityOptions(arr);
        }
    }, [loadingFFSECity, FFSECity])
    useEffect(() => {
        if (FFSESeaport) {
            let arr = [];
            FFSESeaport.map(val => arr.push({ value: val.id, label: val.name }));
            setSeaportOptions(arr);
        }
    }, [loadingFFSESeaport, FFSESeaport])


    useEffect(() => {
        // console.log(FFSeaExpShipperBranchList);
        if (FFSeaExpShipperBranchList) {
            let arr = [];
            FFSeaExpShipperBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setShipperBranchOptions(arr);
        }
    }, [FFSeaExpShipperBranchList]);

    useEffect(() => {
        if (FFSeaExpShipperBranchBankList) {
            let arr = [];
            FFSeaExpShipperBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setShipperBankOptions(arr);
        }
    }, [FFSeaExpShipperBranchBankList]);

    useEffect(() => {
        if (FFSeaExpConsigneeBranchList) {
            let arr = [];
            FFSeaExpConsigneeBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setConsigneeBranchOptions(arr);
        }
    }, [FFSeaExpConsigneeBranchList]);

    useEffect(() => {
        if (FFSeaExpConsigneeBranchBankList) {
            let arr = [];
            FFSeaExpConsigneeBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setConsigneeBankOptions(arr);
        }
    }, [FFSeaExpConsigneeBranchBankList]);


    const initialValues = {
        job_order_id: 0,
        quotation_id: 0,
        shipper_id: 0,
        shipper_branch_id: 0,
        shipper_branch_address_id: 0,
        consignee_id: 0,
        consignee_branch_id: 0,
        consignee_branch_address_id: 0,
        notify_address: "",
        notify_email_address: "",
        place_of_acceptance: "",
        port_of_loading: "",
        port_of_discharge: "",
        place_of_delivery: "",
        vessel_and_voyage_no: "",
        product_description_json: "",
        freight_term: "",
        freight_payable_at: "",
        number_of_original_mdt: "",
        place_of_issue: "",
        place_of_date: "",
        other_particular_address: "",
        other_particular_country: "",
        other_particular_city: "",
        other_particular_state: "",
        other_particular_zipcode: "",
        other_particular_name: "",
        shipped_on_board_date: "",
        delivery_of_goods_apply_to_name: "",
        delivery_of_goods_apply_to_address: "",
        delivery_of_goods_apply_to_email: "",
        delivery_of_goods_apply_to_tax_id: "",
        delivery_of_goods_apply_to_zc: "",
        is_sli_recived: "",
        shipping_line: "",
        type_of_bl: "",
        no_of_copies: "",
        rows: [
            {
                no_of_package: "0",
                goods_description: "",
                gross_weight: "",
                gross_weight_unit: "",
                measurement: "",
                invoice_no: "",
                sb_no: "",
                sb_date: "",
                net_weight: "",
                net_weight_unit: "",
                container_number: "",
                line_seal_no: "",
                seal_type: "",
                volume: "",
                volume_unit: "",
            }
        ]
    }

    const formik = useFormik({
        initialValues: initialValues,
        validate: (values) => applyNoOfCopiesValidation(values, {}),
        onSubmit: (values, { resetForm }) => {
            // console.log(values);
            values.job_order_id = job_order_id;
            values.quotation_id = quotation_id;

            values.product_description_json = values.rows
            // console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }

                let id = atob(b64id);

                if (!id) {
                    toast.error("HBL id not found. Please assign HBL id to update.");
                    return;
                }
                values.id = id;
                axios.post(`${adminMainUrl}/api/freight/forwarding/sea/export/direct-shipment/mbl/update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            // resetForm();
                            //reset all the dropdowns
                            setShipperOrganisationOptions([]);
                            setConsigneeOrganisationOptions([]);
                            setShipperBranchOptions([]);
                            setConsigneeBranchOptions([]);
                            resetForm();
                            navigate(`/flexichain/job-order/freight-forwarding/shipment/sea/export/direct/mbl`)

                            // navigate(`/flexichain/job-order/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    useEffect(() => {
        if (formik.values.other_particular_country) {
            dispatch(getFFSEState(token, user_id, formik.values.other_particular_country));
        }
    }, [formik.values.other_particular_country])
    useEffect(() => {
        if (formik.values.other_particular_state) {
            dispatch(getFFSECity(token, user_id, formik.values.other_particular_state));
        }
    }, [formik.values.other_particular_state])

    useEffect(() => {
        if (FFSeaExpDirectMAWBDetail) {
            // console.log("FFSeaExpDirectMAWBDetail", FFSeaExpDirectMAWBDetail);
            formik.setFieldValue("job_order_id", FFSeaExpDirectMAWBDetail.job_order_id);
            formik.setFieldValue("quotation_id", FFSeaExpDirectMAWBDetail.quotation_id);
            formik.setFieldValue("shipper_id", FFSeaExpDirectMAWBDetail.shipper_id);
            if (FFSeaExpDirectMAWBDetail.shipper_id) {
                handleShipperBranch(FFSeaExpDirectMAWBDetail.shipper_id);
            }
            formik.setFieldValue("shipper_branch_id", FFSeaExpDirectMAWBDetail.shipper_branch_id);

            // formik.setFieldValue("shipper_branch_address_id", FFSeaExpDirectMAWBDetail.shipper_branch_address_id);
            formik.setFieldValue("consignee_id", FFSeaExpDirectMAWBDetail.consignee_id);
            if (FFSeaExpDirectMAWBDetail.consignee_id) {
                handleConsigneeBranch(FFSeaExpDirectMAWBDetail.consignee_id);
            }
            formik.setFieldValue("consignee_branch_id", FFSeaExpDirectMAWBDetail.consignee_branch_id);

            // formik.setFieldValue("consignee_branch_address_id", FFSeaExpDirectMAWBDetail.consignee_branch_address_id);
            formik.setFieldValue("notify_address", FFSeaExpDirectMAWBDetail.notify_address);
            formik.setFieldValue("notify_email_address", FFSeaExpDirectMAWBDetail.notify_email_address);
            formik.setFieldValue("place_of_acceptance", FFSeaExpDirectMAWBDetail.place_of_acceptance);
            formik.setFieldValue("port_of_loading", FFSeaExpDirectMAWBDetail.port_of_loading);
            formik.setFieldValue("port_of_discharge", FFSeaExpDirectMAWBDetail.port_of_discharge);
            formik.setFieldValue("place_of_delivery", FFSeaExpDirectMAWBDetail.place_of_delivery);
            formik.setFieldValue("vessel_and_voyage_no", FFSeaExpDirectMAWBDetail.vessel_and_voyage_no);
            formik.setFieldValue("product_description_json", FFSeaExpDirectMAWBDetail.product_description_json);
            formik.setFieldValue("freight_term", FFSeaExpDirectMAWBDetail.freight_term);
            formik.setFieldValue("freight_payable_at", FFSeaExpDirectMAWBDetail.freight_payable_at);
            formik.setFieldValue("number_of_original_mdt", FFSeaExpDirectMAWBDetail.number_of_original_mdt);
            formik.setFieldValue("place_of_issue", FFSeaExpDirectMAWBDetail.place_of_issue);
            formik.setFieldValue("place_of_date", FFSeaExpDirectMAWBDetail.place_of_date);
            formik.setFieldValue("other_particular_address", FFSeaExpDirectMAWBDetail.other_particular_address);
            formik.setFieldValue("other_particular_country", FFSeaExpDirectMAWBDetail.other_particular_country);
            formik.setFieldValue("other_particular_city", FFSeaExpDirectMAWBDetail.other_particular_city);
            formik.setFieldValue("other_particular_state", FFSeaExpDirectMAWBDetail.other_particular_state);
            formik.setFieldValue("other_particular_zipcode", FFSeaExpDirectMAWBDetail.other_particular_zipcode);
            formik.setFieldValue("shipped_on_board_date", FFSeaExpDirectMAWBDetail.shipped_on_board_date);
            formik.setFieldValue("delivery_of_goods_apply_to_address", FFSeaExpDirectMAWBDetail.delivery_of_goods_apply_to_address);
            formik.setFieldValue("delivery_of_goods_apply_to_email", FFSeaExpDirectMAWBDetail.delivery_of_goods_apply_to_email);
            formik.setFieldValue("delivery_of_goods_apply_to_tax_id", FFSeaExpDirectMAWBDetail.delivery_of_goods_apply_to_tax_id);
            formik.setFieldValue("delivery_of_goods_apply_to_zc", FFSeaExpDirectMAWBDetail.delivery_of_goods_apply_to_zc);
            formik.setFieldValue("is_sli_recived", FFSeaExpDirectMAWBDetail.is_sli_recived);

            // NEW fields
            formik.setFieldValue("delivery_of_goods_apply_to_name", FFSeaExpDirectMAWBDetail.delivery_of_goods_apply_to_name || FFSeaExpDirectMAWBDetail.name || "");
            formik.setFieldValue("other_particular_name", FFSeaExpDirectMAWBDetail.other_particular_name || FFSeaExpDirectMAWBDetail.name || "");
            formik.setFieldValue("shipping_line", FFSeaExpDirectMAWBDetail.shipping_line || "");
            formik.setFieldValue("type_of_bl", FFSeaExpDirectMAWBDetail.type_of_bl || "");
            formik.setFieldValue("no_of_copies", FFSeaExpDirectMAWBDetail.no_of_copies || "");

            // Map rows – map net_weight -> volume, net_weight_unit -> volume_unit
            if (FFSeaExpDirectMAWBDetail?.mbl_product_list && Array.isArray(FFSeaExpDirectMAWBDetail?.mbl_product_list)) {
                const arr = FFSeaExpDirectMAWBDetail.mbl_product_list.map((item) => ({
                    no_of_package: item.no_of_package || "",
                    goods_description: item.goods_description || "",
                    gross_weight: item.gross_weight || "",
                    gross_weight_unit: item.gross_weight_unit || "",
                    measurement: item.measurement || "",
                    invoice_no: item.invoice_no || "",
                    sb_no: item.sb_no || "",
                    sb_date: item.sb_date || "",
                    net_weight: item.net_weight || "",
                    net_weight_unit: item.net_weight_unit || "",
                    container_number: item.container_number || "",
                    line_seal_no: item.line_seal_no || "",
                    seal_type: item.seal_type || "",
                    // Map net_weight -> volume, net_weight_unit -> volume_unit
                    volume: item.net_weight || "",
                    volume_unit: item.net_weight_unit || "",
                }));

                formik.setFieldValue("rows", arr);
            }
        }
    }, [FFSeaExpDirectMAWBDetail])

    useEffect(() => {
        let num1 = !isNaN(Number(formik.values.weight_charge_prepaid)) ? Number(formik.values.weight_charge_prepaid) : 0;
        let num2 = !isNaN(Number(formik.values.valuation_charge_prepaid)) ? Number(formik.values.valuation_charge_prepaid) : 0;
        let num3 = !isNaN(Number(formik.values.tax_prepaid)) ? Number(formik.values.tax_prepaid) : 0;
        let num4 = !isNaN(Number(formik.values.total_due_agent_prepaid)) ? Number(formik.values.total_due_agent_prepaid) : 0;
        let num5 = !isNaN(Number(formik.values.total_due_carrier_prepaid)) ? Number(formik.values.total_due_carrier_prepaid) : 0;
        formik.setFieldValue("total_prepaid", num1 + num2 + num3 + num4 + num5);
    }, [
        formik.values.weight_charge_prepaid,
        formik.values.valuation_charge_prepaid,
        formik.values.tax_prepaid,
        formik.values.total_due_agent_prepaid,
        formik.values.total_due_carrier_prepaid,
    ]);

    useEffect(() => {
        let num1 = !isNaN(Number(formik.values.weight_charge_collect)) ? Number(formik.values.weight_charge_collect) : 0;
        let num2 = !isNaN(Number(formik.values.valuation_charge_collect)) ? Number(formik.values.valuation_charge_collect) : 0;
        let num3 = !isNaN(Number(formik.values.tax_collect)) ? Number(formik.values.tax_collect) : 0;
        let num4 = !isNaN(Number(formik.values.total_due_agent_collect)) ? Number(formik.values.total_due_agent_collect) : 0;
        let num5 = !isNaN(Number(formik.values.total_due_carrier_collect)) ? Number(formik.values.total_due_carrier_collect) : 0;
        formik.setFieldValue("total_collect", num1 + num2 + num3 + num4 + num5);
    }, [
        formik.values.weight_charge_collect,
        formik.values.valuation_charge_collect,
        formik.values.tax_collect,
        formik.values.total_due_agent_collect,
        formik.values.total_due_carrier_collect,
    ]);


    const [disableDownloadPDF, setDisableDownloadPDF] = useState(false);
    const [disableDownloadDOC, setDisableDownloadDOC] = useState(false);


    const downloadSLIPDF = () => {
        setDisableDownloadPDF(true);
        let config = { headers: { 'auth-token': token, user_id: user_id }, responseType: 'blob', };
        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/sea/export/hbl/sli-pdf-download`, config)
                .then(response => {
                    if (response.status == 200) {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'FlexichainSLI.pdf');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setDisableDownloadPDF(false);
                    } else {
                        toast.error(response.error.message);
                        setDisableDownloadPDF(false);
                    }
                }).catch(error => {
                    console.log(error);
                    toast.error(error.message);
                    setDisableDownloadPDF(false);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
            setDisableDownloadPDF(false);
        }
    }

    const downloadSLIDOC = () => {
        setDisableDownloadDOC(true);
        let config = {
            headers: { 'auth-token': token, user_id: user_id },
            responseType: 'blob' // Ensure the response is treated as a binary blob
        };

        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/air/export/hawb/sli-doc-download`, config)
                .then(response => {
                    if (response.status === 200) {
                        // Create a Blob object from the response data
                        const blob = new Blob([response.data], { type: 'application/msword' });
                        const url = window.URL.createObjectURL(blob);

                        // Create an anchor element and trigger the download
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'FlexichainSLI.doc'); // Set the filename
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link); // Clean up the DOM
                        setDisableDownloadDOC(false);
                    } else {
                        toast.error(response.error.message || "Error downloading the document");
                        setDisableDownloadDOC(false);
                    }
                })
                .catch(error => {
                    console.error(error);
                    toast.error(error.message || "Error during download");
                    setDisableDownloadDOC(false);
                });
        } catch (error) {
            console.error(error);
            toast.error(error.message || "Unexpected error occurred");
            setDisableDownloadDOC(false);
        }
    };

    // ---- Handler for adding a new row via modal ----
    const handleAddRowFromModal = () => {
        // Get the last row index
        const lastIndex = formik.values.rows.length - 1;
        const lastRow = formik.values.rows[lastIndex];

        // Check if the last row has any cargo data (marks, description, weight, volume)
        const hasCargo = lastRow.no_of_package || lastRow.goods_description || lastRow.gross_weight || lastRow.volume;

        let updatedRows = [...formik.values.rows];

        if (hasCargo) {
            // If the last row already has cargo data, add a new row
            updatedRows.push({
                container_number: newRowData.container_number || "",
                line_seal_no: newRowData.line_seal_no || "",
                seal_type: newRowData.seal_type || "",
                seal_number: newRowData.seal_number || "",
                invoice_no: newRowData.invoice_no || "",
                no_of_package: newRowData.no_of_package || "",
                goods_description: newRowData.goods_description || "",
                gross_weight: newRowData.gross_weight || "",
                gross_weight_unit: newRowData.gross_weight_unit || "",
                volume: newRowData.volume || "",
                volume_unit: newRowData.volume_unit || "",
                sb_no: "",
                sb_date: "",
                net_weight: "",
                net_weight_unit: "",
                measurement: "",
            });
        } else {
            // Otherwise, update the last row with modal data
            updatedRows[lastIndex] = {
                ...lastRow,
                container_number: newRowData.container_number || "",
                line_seal_no: newRowData.line_seal_no || "",
                seal_type: newRowData.seal_type || "",
                seal_number: newRowData.seal_number || "",
                invoice_no: newRowData.invoice_no || "",
                no_of_package: newRowData.no_of_package || "",
                goods_description: newRowData.goods_description || "",
                gross_weight: newRowData.gross_weight || "",
                gross_weight_unit: newRowData.gross_weight_unit || "",
                volume: newRowData.volume || "",
                volume_unit: newRowData.volume_unit || "",
            };
        }

        formik.setFieldValue("rows", updatedRows);
        setNewRowData({
            container_number: '',
            line_seal_no: '',
            seal_type: '',
            seal_number: '',
            invoice_no: '',
            no_of_package: '',
            goods_description: '',
            gross_weight: '',
            gross_weight_unit: 'Kg',
            volume: '',
            volume_unit: 'CBM',
        });
        setShowAddRowModal(false);
    };

    // ---- Determine if Seal Number column should be shown ----
    const showSealNumberColumn = formik.values.rows.some(row => row.seal_type && row.seal_type !== '');

    // ---- Determine if Cargo Data columns should be shown (Marks, Cargo Description, Gross Weight, Volume) ----
    const hasCargoData = formik.values.rows.some(row =>
        row.no_of_package || row.goods_description || row.gross_weight || row.volume
    );

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="row">
                    <h3 className='mt-2'>Direct Shipment MBL</h3>
                    <h4 className='mt-2'>Party Details</h4>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                SLI received
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <select
                                    className='form-control form-control-sm'
                                    name="is_sli_recived"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.is_sli_recived}
                                >
                                    <option value="" disabled>-</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2 d-flex align-items-center justify-content-end">
                        <div className="row d-flex justify-content-end">
                            {accessedPermission.includes("ff_se_console_shipment_hbl_sli_download") && <div className="col-md-6"><button className="btn btn-sm btn-primary" type="button" onClick={downloadSLIPDF} disabled={disableDownloadPDF}>{disableDownloadPDF ? <><i className="fas fa-spinner fa-spin"></i> Downloading...</> : <><i className="fa-solid fa-download"></i>  Download SLI (PDF)</>}</button></div>}
                            {/* {accessedPermission.includes("ff_se_console_shipment_hbl_sli_download") && <div className="col-md-6"><button className="btn btn-sm btn-primary" type="button" onClick={downloadSLIDOC} disabled={disableDownloadDOC} style={{ whiteSpace: "nowrap" }}>{disableDownloadDOC ? <><i className="fas fa-spinner fa-spin"></i> Downloading...</> : <><i className="fa-solid fa-download"></i>  Download SLI (DOC)</>}</button></div>} */}
                            {accessedPermission.includes("ff_se_console_shipment_hbl_sli_download") && <div className="col-md-6"><Link className="btn btn-sm btn-primary" type="button" style={{ whiteSpace: "nowrap" }} to={`${adminMainUrl}/FreightForwardingSLI/FF_AI_SLI.docx`}>{disableDownloadDOC ? <><i className="fas fa-spinner fa-spin"></i> Downloading...</> : <><i className="fa-solid fa-download"></i>  Download SLI (DOC)</>}</Link></div>
                            }

                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Shipper
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={shipperOrganisationOptions}
                                    styles={customStyles}
                                    name="shipper_id"
                                    onChange={option => {
                                        formik.setFieldValue("shipper_branch_id", "");
                                        setShipperBranchOptions([]);
                                        formik.setFieldValue('shipper_id', option.value);
                                        handleShipperBranch(option.value);
                                    }}
                                    value={shipperOrganisationOptions.find(option => option.value === formik.values.shipper_id || null)}
                                    isLoading={loadingOrganisation}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Shipper Branch
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={shipperBranchOptions}
                                    styles={customStyles}
                                    name="shipper_branch_id"
                                    onChange={option => {
                                        formik.setFieldValue('shipper_branch_id', option.value);
                                        handleShipperBanks(option.value);
                                    }}
                                    value={shipperBranchOptions.find(option => option.value === formik.values.shipper_branch_id || null)}
                                    isLoading={loadingFFSeaExpShipperBranchList}
                                // isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Consignee
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={consigneeOrganisationOptions}
                                    styles={customStyles}
                                    name="quotation_id"
                                    onChange={option => {
                                        setConsigneeBranchOptions([]);
                                        formik.setFieldValue("consignee_branch_id", "");
                                        formik.setFieldValue('consignee_id', option.value);
                                        handleConsigneeBranch(option.value);
                                    }}
                                    value={consigneeOrganisationOptions.find(option => option.value === formik.values.consignee_id || null)}
                                    isLoading={loadingOrganisation}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Consignee Branch
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={consigneeBranchOptions}
                                    styles={customStyles}
                                    name="consignee_branch_id"
                                    onChange={option => {
                                        formik.setFieldValue('consignee_branch_id', option.value);
                                        handleConsigneeBanks(option.value);
                                    }}
                                    value={consigneeBranchOptions.find(option => option.value === formik.values.consignee_branch_id || null)}
                                    isLoading={loadingFFSeaExpShipperBranchList}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>


                    {/* Notify  */}
                    <div className="col-md-12 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Notify Address
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <textarea
                                    className='form-control'
                                    id="notify_address"
                                    name="notify_address"
                                    value={formik.values.notify_address}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={250}
                                ></textarea>
                            </div>
                        </div>
                    </div>
                    <InputTextJSX labelText={"Notify Email"} nameValue={"notify_email_address"} value={formik.values.notify_email_address} onChange={formik.handleChange} maxLength={100} />
                    <InputTextJSX labelText={"Place of acceptance"} nameValue={"place_of_acceptance"} value={formik.values.place_of_acceptance} onChange={formik.handleChange} maxLength={250} />

                    {/* Ports of loading and discharge */}
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Port of Loading
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={seaportOptions}
                                    styles={customStyles}
                                    name="port_of_loading"
                                    onChange={option => {
                                        formik.setFieldValue('port_of_loading', option.value);
                                    }}
                                    value={seaportOptions.find(option => option.value == formik.values.port_of_loading || null)}
                                    isLoading={loadingFFSeaExpConsigneeBranchBankList}
                                // isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Port of Discharge
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={seaportOptions}
                                    styles={customStyles}
                                    name="port_of_discharge"
                                    onChange={option => {
                                        formik.setFieldValue('port_of_discharge', option.value);
                                    }}
                                    value={seaportOptions.find(option => option.value == formik.values.port_of_discharge || null)}
                                    isLoading={loadingFFSeaExpConsigneeBranchBankList}
                                // isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <InputTextJSX labelText={"Place of delivery"} nameValue={"place_of_delivery"} value={formik.values.place_of_delivery} onChange={formik.handleChange} maxLength={250} />
                    <InputTextJSX labelText={"Vessel & Voyage No."} nameValue={"vessel_and_voyage_no"} value={formik.values.vessel_and_voyage_no} onChange={formik.handleChange} maxLength={250} />

                    {/* NEW: Shipping Line */}
                    <InputTextJSX labelText={"Shipping Line"} nameValue={"shipping_line"} value={formik.values.shipping_line} onChange={formik.handleChange} maxLength={100} />

                    <InputTextJSX labelText={"Freight Term"} nameValue={"freight_term"} value={formik.values.freight_term} onChange={formik.handleChange} maxLength={250} />
                    <InputTextJSX labelText={"Freight Payable At"} nameValue={"freight_payable_at"} value={formik.values.freight_payable_at} onChange={formik.handleChange} maxLength={250} />

                    {/* NEW: Type of BL and No. of copies */}
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label mb-0'>
                                Type of BL
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={blTypeOptions}
                                    styles={customStyles}
                                    name="type_of_bl"
                                    onChange={option => handleTypeOfBlSelectChange(option, formik)}
                                    isClearable
                                    value={blTypeOptions.find(option => option.value === formik.values.type_of_bl) || null}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={`col-md-6 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                No. of copies
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input
                                    type="text"
                                    maxLength={2}
                                    className="form-control form-control-sm"
                                    id="no_of_copies"
                                    name="no_of_copies"
                                    value={formik.values.no_of_copies}
                                    onBlur={formik.handleBlur}
                                    onChange={(e) => handleNoOfCopiesInputChange(e, formik)}
                                    disabled={!formik.values.type_of_bl}
                                />
                                {formik.errors.no_of_copies && formik.touched.no_of_copies && (
                                    <div className="text-danger" style={{ fontSize: '11px', marginTop: '2px' }}>
                                        {formik.errors.no_of_copies}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* <div className={`col-md-6 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                No. of Original MTDs
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input
                                    type="text"
                                    maxlength={10}
                                    className="form-control form-control-sm"
                                    id="number_of_original_mdt"
                                    name="number_of_original_mdt"
                                    value={formik.values.number_of_original_mdt}
                                    onChange={formik.handleChange}
                                    onInput={(event) => {
                                        let value = event.target.value;
                                        value = value.replace(/[^0-9]/g, '');
                                        event.target.value = value;
                                    }}
                                />
                            </div>
                        </div>
                    </div> */}
                    <InputTextJSX labelText={"Place of issue"} nameValue={"place_of_issue"} value={formik.values.place_of_issue} onChange={formik.handleChange} />
                    <div className={`col-md-6 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Date of Issue
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    id="place_of_date"
                                    name="place_of_date"
                                    value={formik.values.place_of_date}
                                    onChange={formik.handleChange}
                                />
                            </div>
                        </div>
                    </div>


                    <h4 className='mt-2'>For delivery of goods please apply to:</h4>
                    <InputTextJSX labelText={"Name"} nameValue={"delivery_of_goods_apply_to_name"} value={formik.values.delivery_of_goods_apply_to_name} onChange={formik.handleChange} maxLength={100} />
                    <InputTextJSX labelText={"Address"} nameValue={"delivery_of_goods_apply_to_address"} value={formik.values.delivery_of_goods_apply_to_address} onChange={formik.handleChange} maxLength={250} />
                    <InputTextJSX labelText={"Email"} nameValue={"delivery_of_goods_apply_to_email"} value={formik.values.delivery_of_goods_apply_to_email} onChange={formik.handleChange} maxlength={60} />
                    <InputTextJSX labelText={"Tax ID"} nameValue={"delivery_of_goods_apply_to_tax_id"} value={formik.values.delivery_of_goods_apply_to_tax_id} onChange={formik.handleChange} maxlength={20} />
                    <InputTextJSX labelText={"ZC"} nameValue={"delivery_of_goods_apply_to_zc"} value={formik.values.delivery_of_goods_apply_to_zc} onChange={formik.handleChange} maxlength={10} />

                    <h4 className='mt-2'>Rate Description</h4>
                    <div className="table-responsive">
                        <table className="table table-striped table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">Container No.(s)*</th>
                                    <th scope="col">Line Seal No.*</th>
                                    <th scope="col">Seal Type</th>
                                    {showSealNumberColumn && <th scope="col">Seal Number</th>}
                                    <th scope="col">Invoice Number</th>
                                    {hasCargoData && <th scope="col">Marks & Number</th>}
                                    {hasCargoData && <th scope="col">Cargo Description</th>}
                                    {hasCargoData && <th scope="col">Gross Cargo Weight</th>}
                                    {hasCargoData && <th scope="col">Volume</th>}
                                    <th scope="col">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {formik.values.rows.map((row, index) => (
                                    <tr key={index}>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].container_number`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                maxLength={100}
                                                value={row.container_number}
                                                pattern="[A-Za-z]{4}[0-9]{7}"
                                                title="Container number must be 4 letters followed by 7 digits (e.g., ABCD1234567)"
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    // Remove any non-alphanumeric characters
                                                    value = value.replace(/[^A-Za-z0-9]/g, '');
                                                    // Limit to 11 characters
                                                    if (value.length > 11) value = value.slice(0, 11);
                                                    event.target.value = value;
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].line_seal_no`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.line_seal_no}
                                                maxLength={50}
                                                required
                                            />
                                        </td>
                                        <td>
                                            <select
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].seal_type`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.seal_type}
                                            >
                                                <option value="">-</option>
                                                {sealTypeOptions.map(option => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                        {showSealNumberColumn && (
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    name={`rows[${index}].seal_number`}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={row.seal_number}
                                                    maxLength={50}
                                                    placeholder="Enter seal number"
                                                />
                                            </td>
                                        )}
                                        <td>
                                            <input
                                                type="text"
                                                maxLength={50}
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].invoice_no`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.invoice_no}
                                            />
                                        </td>
                                        {hasCargoData && (
                                            <td>
                                                <input
                                                    type="text"
                                                    maxLength={50}
                                                    className="form-control form-control-sm"
                                                    name={`rows[${index}].no_of_package`}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={row.no_of_package}
                                                />
                                            </td>
                                        )}
                                        {hasCargoData && (
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    name={`rows[${index}].goods_description`}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={row.goods_description}
                                                    maxLength={250}
                                                />
                                            </td>
                                        )}
                                        {hasCargoData && (
                                            <td>
                                                <div className="d-flex align-items-center gap-1" style={{ minWidth: '120px' }}>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        style={{ width: '65%' }}
                                                        name={`rows[${index}].gross_weight`}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={row.gross_weight}
                                                        maxLength={10}
                                                        placeholder="Weight"
                                                        onInput={(event) => {
                                                            let value = event.target.value;
                                                            value = value.replace(/[^0-9.]/g, '');
                                                            const parts = value.split('.');
                                                            if (parts.length > 2) {
                                                                value = parts[0] + '.' + parts[1];
                                                            }
                                                            if (parts[1] && parts[1].length > 2) {
                                                                value = parts[0] + '.' + parts[1].substring(0, 2);
                                                            }
                                                            event.target.value = value;
                                                        }}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        style={{ width: '35%' }}
                                                        name={`rows[${index}].gross_weight_unit`}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={row.gross_weight_unit}
                                                        placeholder="Unit"
                                                    />
                                                </div>
                                            </td>
                                        )}
                                        {hasCargoData && (
                                            <td>
                                                <div className="d-flex align-items-center gap-1" style={{ minWidth: '120px' }}>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        style={{ width: '65%' }}
                                                        name={`rows[${index}].volume`}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={row.volume}
                                                        maxLength={10}
                                                        placeholder="Volume"
                                                        onInput={(event) => {
                                                            let value = event.target.value;
                                                            value = value.replace(/[^0-9.]/g, '');
                                                            const parts = value.split('.');
                                                            if (parts.length > 2) {
                                                                value = parts[0] + '.' + parts[1];
                                                            }
                                                            if (parts[1] && parts[1].length > 2) {
                                                                value = parts[0] + '.' + parts[1].substring(0, 2);
                                                            }
                                                            event.target.value = value;
                                                        }}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        style={{ width: '35%' }}
                                                        name={`rows[${index}].volume_unit`}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={row.volume_unit}
                                                        placeholder="Unit"
                                                    />
                                                </div>
                                            </td>
                                        )}
                                        <td>
                                            {formik.values.rows.length > 1 && (
                                                <button
                                                    type="button"
                                                    title='Remove row'
                                                    className="btn btn-sm btn-danger me-1"
                                                    onClick={() => {
                                                        const newRows = formik.values.rows.filter(
                                                            (_, i) => i !== index
                                                        );
                                                        formik.setFieldValue("rows", newRows);
                                                    }}
                                                >
                                                    -
                                                </button>
                                            )}
                                            {index === formik.values.rows.length - 1 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-primary ms-1"
                                                    onClick={() => setShowAddRowModal(true)}
                                                >
                                                    Add More
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className={`col-md-6 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Ship On Board Date:
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    id="shipped_on_board_date"
                                    name="shipped_on_board_date"
                                    value={formik.values.shipped_on_board_date}
                                    onChange={formik.handleChange}
                                    min={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                        </div>
                    </div>

                    <h4 className='mt-2'>Other Particulars</h4>
                    <InputTextJSX labelText={"Name"} nameValue={"other_particular_name"} value={formik.values.other_particular_name} onChange={formik.handleChange} maxLength={100} />
                    <InputTextJSX labelText={"Address"} nameValue={"other_particular_address"} value={formik.values.other_particular_address} onChange={formik.handleChange} maxLength={250} />
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Country
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={countryOptions}
                                    styles={customStyles}
                                    name="other_particular_country"
                                    onChange={option => {
                                        formik.setFieldValue('other_particular_country', option.value);
                                    }}
                                    value={countryOptions.find(option => option.value == formik.values.other_particular_country || null)}
                                    isLoading={loadingFFSECountry}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                State
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={stateOptions}
                                    styles={customStyles}
                                    name="other_particular_state"
                                    onChange={option => {
                                        formik.setFieldValue('other_particular_state', option.value);
                                    }}
                                    value={stateOptions.find(option => option.value == formik.values.other_particular_state || null)}
                                    isLoading={loadingFFSEState}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                City
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={cityOptions}
                                    styles={customStyles}
                                    name="other_particular_city"
                                    onChange={option => {
                                        formik.setFieldValue('other_particular_city', option.value);
                                    }}
                                    value={cityOptions.find(option => option.value == formik.values.other_particular_city || null)}
                                    isLoading={loadingFFSECity}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    {/* <InputTextJSX labelText={"Zip Code"} nameValue={"other_particular_zipcode"} value={formik.values.other_particular_zipcode} onChange={formik.handleChange} maxlength={6} /> */}
                    <div className={`col-md-6 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Zip Code
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <input
                                    type="text"
                                    maxLength={6}
                                    className="form-control form-control-sm"
                                    id={"other_particular_zipcode"}
                                    name={"other_particular_zipcode"}
                                    value={formik.values.other_particular_zipcode}
                                    onChange={formik.handleChange}
                                    onInput={(event) => {
                                        let value = event.target.value;
                                        value = value.replace(/[^0-9]/g, '');
                                        event.target.value = value;
                                    }}
                                    onBlur={formik.handleBlur}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row d-flex justify-content-end mt-2">
                    <div className="col-md-6 d-flex justify-content-end">
                        <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                        </button>
                    </div>
                </div>
            </form>

            {/* ── Add Row Modal ── */}
            <Modal show={showAddRowModal} onHide={() => setShowAddRowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Rate Description Row</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12 mt-2">
                            <label className="form-label">Marks & Number</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                value={newRowData.no_of_package}
                                onChange={(e) => setNewRowData({ ...newRowData, no_of_package: e.target.value })}
                                maxLength={50}
                            />
                        </div>
                        <div className="col-md-12 mt-2">
                            <label className="form-label">Cargo Description</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                value={newRowData.goods_description}
                                onChange={(e) => setNewRowData({ ...newRowData, goods_description: e.target.value })}
                                maxLength={250}
                            />
                        </div>
                        <div className="col-md-12 mt-2">
                            <label className="form-label">Gross Cargo Weight</label>
                            <div className="d-flex gap-2">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    style={{ flex: 2 }}
                                    value={newRowData.gross_weight}
                                    onChange={(e) => setNewRowData({ ...newRowData, gross_weight: e.target.value })}
                                    placeholder="Weight"
                                    maxLength={10}
                                    onInput={(e) => {
                                        let val = e.target.value.replace(/[^0-9.]/g, '');
                                        const parts = val.split('.');
                                        if (parts.length > 2) val = parts[0] + '.' + parts[1];
                                        if (parts[1] && parts[1].length > 2) val = parts[0] + '.' + parts[1].substring(0, 2);
                                        e.target.value = val;
                                    }}
                                />
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    style={{ flex: 1 }}
                                    value={newRowData.gross_weight_unit}
                                    onChange={(e) => setNewRowData({ ...newRowData, gross_weight_unit: e.target.value })}
                                    placeholder="Unit"
                                />
                            </div>
                        </div>
                        <div className="col-md-12 mt-2">
                            <label className="form-label">Volume</label>
                            <div className="d-flex gap-2">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    style={{ flex: 2 }}
                                    value={newRowData.volume}
                                    onChange={(e) => setNewRowData({ ...newRowData, volume: e.target.value })}
                                    placeholder="Volume"
                                    maxLength={10}
                                    onInput={(e) => {
                                        let val = e.target.value.replace(/[^0-9.]/g, '');
                                        const parts = val.split('.');
                                        if (parts.length > 2) val = parts[0] + '.' + parts[1];
                                        if (parts[1] && parts[1].length > 2) val = parts[0] + '.' + parts[1].substring(0, 2);
                                        e.target.value = val;
                                    }}
                                />
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    style={{ flex: 1 }}
                                    value={newRowData.volume_unit}
                                    onChange={(e) => setNewRowData({ ...newRowData, volume_unit: e.target.value })}
                                    placeholder="Unit"
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-sm btn-secondary" onClick={() => setShowAddRowModal(false)}>
                        Cancel
                    </button>
                    <button className="btn btn-sm btn-primary" onClick={handleAddRowFromModal}>
                        Add Row
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DirectShipmentSEMBLEdit